/* eslint-disable*/
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
// import {
//   usePopupState,
//   bindHover,
//   bindPopover as bindHoverPopover,
// } from 'material-ui-popup-state/hooks';
// import PopupState, { bindTrigger, bindPopover, bindHover } from 'material-ui-popup-state';
import PopupState, { bindTrigger, bindPopover, bindHover } from 'material-ui-popup-state';
import Popover from '@material-ui/core/Popover';
import HoverPopover from 'material-ui-popup-state/HoverPopover';
import SunEditor from 'suneditor-react';
import { FastField, Formik, Form, Field } from 'formik';
import { object, string, ref, number, date } from 'yup';
import useStyles from '../../screens/Main/Main.style';
import 'suneditor/dist/css/suneditor.min.css';
import InfoIcon from '@material-ui/icons/Info';
import EditIcon from '@material-ui/icons/Edit';
import {
  Typography,
  TextField,
  Button,
  CircularProgress,
  Box,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Breadcrumbs,
  Link,
  Divider,
  AppBar,
  Tabs,
  Tab,
  RadioGroup,
  FormControlLabel,
  Radio,
  Badge,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Toolbar,
  Slide,
  ClickAwayListener,
  // Popover,
} from '@material-ui/core';
import align from 'suneditor/src/plugins/submenu/align';
import fontColor from 'suneditor/src/plugins/submenu/fontColor';
import fontSize from 'suneditor/src/plugins/submenu/fontSize';
import formatBlock from 'suneditor/src/plugins/submenu/formatBlock';
import hiliteColor from 'suneditor/src/plugins/submenu/hiliteColor';
import horizontalRule from 'suneditor/src/plugins/submenu/horizontalRule';
import lineHeight from 'suneditor/src/plugins/submenu/lineHeight';
import list from 'suneditor/src/plugins/submenu/list';
import paragraphStyle from 'suneditor/src/plugins/submenu/paragraphStyle';
import table from 'suneditor/src/plugins/submenu/table';
import template from 'suneditor/src/plugins/submenu/template';
import textStyle from 'suneditor/src/plugins/submenu/textStyle';
import link from 'suneditor/src/plugins/dialog/link';
import { stubTrue } from 'lodash';
import usePractice from '../../hooks/usePractice';
import DOMPurify from 'dompurify';
import moment from 'moment';

export default function InfoPopoverComments({ dashBoardComment }) {
  const classes = useStyles();
  const { updateComment } = usePractice();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showCommentEditor, setShowCommentEditor] = React.useState(false);
  const [comment, setComment] = React.useState(dashBoardComment?.comment);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  // const sanitizedHTML = DOMPurify.sanitize(dashBoardComment?.comment);
  const sanitizedHTML = DOMPurify.sanitize(comment);
  React.useEffect(() => {
    if (dashBoardComment?.titleText?.toLowerCase() == 'header') {
      const comment = dashBoardComment?.comment;

      // Calculate last year
      const lastYear = new Date().getFullYear() - 1;

      // Regular expression to match [year] or a 4-digit number
      const regex = /\[year\]|\d{4}/g;

      // Replace [year] or any 4-digit number with last year's value
      const updatedComment = comment.replace(regex, lastYear.toString());
      setComment(updatedComment);
      // console.log(updatedComment, 6666);
    } else {
      setComment(dashBoardComment?.comment);
    }
  }, [dashBoardComment?.comment]);
  const spanRef = useRef(null);
  return (
    <>
      <Box className={classes.popoverOuter} display="flex">
        <PopupState variant="popover" popupId="demo-popup-popover">
          {(popupState) => (
            <div>
              <span ref={spanRef} {...bindHover(popupState)}>
                {(dashBoardComment?.titleText?.toLowerCase() != 'header' ? (
                  dashBoardComment?.titleText
                ) : (
                  <>
                    {' '}
                    <InfoIcon aria-haspopup="true" className={classes.InfoIconStyle} />
                  </>
                )) || ''}
              </span>
              <HoverPopover
                className={classes.TableTooltipBoxText}
                {...bindPopover(popupState)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                onMouseLeave={() => {
                  popupState.close();
                  setShowCommentEditor(false);
                }}
              >
                <Typography variant="body1">
                  <div dangerouslySetInnerHTML={{ __html: sanitizedHTML || '' }} />
                </Typography>

                <Box className={classes.TooltipEditedDate} mt={2}>
                  <Typography variant="body1">
                    Edited {moment(dashBoardComment?.updatedAt).format('MMM D') || ''}
                  </Typography>
                  {!showCommentEditor && (
                    <EditIcon
                      onClick={() => {
                        setShowCommentEditor(true);
                        popupState.close();
                      }}
                    />
                  )}
                </Box>
              </HoverPopover>
            </div>
          )}
        </PopupState>
        {showCommentEditor && (
          <Popover
            className={classes.TableTooltipBoxText}
            open={showCommentEditor} // Control open state with showCommentEditor
            onClose={() => setShowCommentEditor(false)} // Close popover
            anchorEl={spanRef.current}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <Formik
              enableReinitialize={true}
              initialValues={{
                comment: dashBoardComment?.comment || '',
              }}
              onSubmit={async (values, actions) => {
                let result = null;

                if (dashBoardComment?.id) {
                  result = await updateComment({
                    dashBoardCommentId: dashBoardComment?.id,
                    comment: values?.comment,
                  });
                } else {
                  dashBoardComment['comment'] = values?.comment;
                  result = await updateComment({
                    dashBoardCommentObj: dashBoardComment,
                  });
                }

                if (result.status) {
                  setComment(values?.comment);
                }

                actions.resetForm();
                setShowCommentEditor(false);
              }}
            >
              {({ submitForm, setFieldValue }) => (
                <Form>
                  <Box mt={2} className={classes.TooltipEditor}>
                    <SunEditor
                      autoFocus={true}
                      lang="en"
                      name="comment"
                      onChange={(content) => {
                        setFieldValue('comment', content);
                      }}
                      setContents={sanitizedHTML || ''}
                      setOptions={{
                        showPathLabel: false,
                        placeholder: '',
                        plugins: [
                          fontSize,
                          formatBlock,
                          'bold',
                          'italic',
                          'underline',
                          align,
                          list,
                          'indent',
                        ],
                        buttonList: [
                          ['fontSize', 'formatBlock'],
                          ['bold', 'italic', 'underline'],
                          ['align', 'list', 'indent'],
                        ],
                        fontSize: ['8', '10', '12', '14', '15', '16'],
                        formats: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
                      }}
                      height="auto"
                    />
                  </Box>
                  <Box display="flex" justifyContent="space-between" mt={2}>
                    <Box className={classes.TooltipCancelBtn}>
                      <Button
                        variant="text"
                        onClick={() => {
                          setShowCommentEditor(false);
                          // popupState.close(); // Correctly call the close method
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                    <Box className={classes.TooltipSaveBtn}>
                      <Button
                        variant="contained"
                        onClick={() => {
                          submitForm();
                        }}
                      >
                        Save
                      </Button>
                    </Box>
                  </Box>
                </Form>
              )}
            </Formik>
          </Popover>
        )}
        {/* 
      <Formik
            enableReinitialize={true}
            initialValues={{
              comment: dashBoardComment?.comment || '',
            }}
            onSubmit={async (values, actions) => {
              let result = null;

              if (dashBoardComment?.id) {
                result = await updateComment({
                  dashBoardCommentId: dashBoardComment?.id,
                  comment: values?.comment,
                });
              } else {
                dashBoardComment['comment'] = values?.comment;
                result = await updateComment({
                  dashBoardCommentObj: dashBoardComment,
                });
              }

              if (result.status) {
                setComment(values?.comment);
              }

              actions.resetForm();
              setShowCommentEditor(false);
            }}
          >
            {({ submitForm, setFieldValue }) => (
              <Form>
                <Box mt={2} className={classes.TooltipEditor}>
                  <SunEditor
                    autoFocus={true}
                    lang="en"
                    name="comment"
                    onChange={(content) => {
                      setFieldValue('comment', content);
                    }}
                    setContents={sanitizedHTML || ''}
                    setOptions={{
                      showPathLabel: false,
                      placeholder: '',
                      plugins: [
                        fontSize,
                        formatBlock,
                        'bold',
                        'italic',
                        'underline',
                        align,
                        list,
                        'indent',
                      ],
                      buttonList: [
                        ['fontSize', 'formatBlock'],
                        ['bold', 'italic', 'underline'],
                        ['align', 'list', 'indent'],
                      ],
                      fontSize: ['8', '10', '12', '14', '15', '16'],
                      formats: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
                    }}
                    height="auto"
                  />
                </Box>
                <Box display="flex" justifyContent="space-between" mt={2}>
                  <Button
                    variant="text"
                    onClick={() => {
                      setShowCommentEditor(false);
                      popupState.close(); // Correctly call the close method
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      submitForm();
                    }}
                  >
                    Save
                  </Button>
                </Box>
              </Form>
            )}
          </Formik> */}
        {/* <PopupState variant="popover" popupId="demo-popup-popover">
        {(popupState) => {
          console.log('showCommentEditor ::', showCommentEditor);

          const triggerProps = bindHover(popupState);
          const popoverProps = bindPopover(popupState);
          return (
            <div>
              <span variant="contained" {...triggerProps}>
                {dashBoardComment?.titleText || ''}
              </span>
              <span variant="contained" {...bindHover(popupState)} {...bindToggle(popupState)}>
                {dashBoardComment?.titleText || ''}
              </span>

              <Popover
                className={classes.TableTooltipBoxText}
                {...popoverProps}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                onMouseLeave={() => {
                  popupState.close();
                  setShowCommentEditor(false);
                }}
              >
                <Typography variant="body1">
                  <div dangerouslySetInnerHTML={{ __html: sanitizedHTML || '' }} />
                </Typography>
                <If condition={showCommentEditor}>
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      question: dashBoardComment?.comment || '',
                    }}
                    onSubmit={async (values, actions) => {
                      let result = null;

                      if (dashBoardComment?.id) {
                        result = await updateComment({
                          dashBoardCommentId: dashBoardComment?.id,
                          comment: values?.comment,
                        });
                      } else {
                        dashBoardComment['comment'] = values?.comment;
                        result = await updateComment({
                          dashBoardCommentObj: dashBoardComment,
                        });
                      }

                      if (result.status) {
                        setComment(values?.comment);
                      }

                      actions.resetForm();
                      setShowCommentEditor(false);
                    }}
                  >
                    {({
                      errors,
                      isSubmitting,
                      isValid,
                      dirty,
                      touched,
                      setFieldValue,
                      setFieldTouched,
                      setFieldError,
                      submitForm,
                      values,
                      resetForm,
                    }) => {
                      return (
                        <Form>
                          <Box mt={2} className={classes.TooltipEditor}>
                            <SunEditor
                              as={TextField}
                              autoFocus={true}
                              lang="en"
                              name="comment"
                              onChange={(content, event) => {
                                setFieldValue(`comment`, content);
                              }}
                              setContents={sanitizedHTML || ''}
                              setOptions={{
                                showPathLabel: false,
                                placeholder: '',
                                plugins: [
                                  fontSize,
                                  formatBlock,
                                  'bold',
                                  'italic',
                                  'underline',
                                  align,
                                  list,
                                  'indent',
                                ],
                                buttonList: [
                                  ['fontSize', 'formatBlock'],
                                  ['bold', 'italic', 'underline'],
                                  ['align', 'list', 'indent'],
                                ],
                                fontSize: ['8', '10', '12', '14', '15', '16'],
                                formats: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
                              }}
                              height="auto"
                            />
                          </Box>
                          <Box display="flex" justifyContent="space-between" mt={2}>
                            <Box className={classes.TooltipCancelBtn}>
                              <Button
                                variant="text"
                                onClick={() => {
                                  setShowCommentEditor(false);
                                  popupState.close;
                                }}
                              >
                                Cancel
                              </Button>
                            </Box>
                            <Box className={classes.TooltipSaveBtn}>
                              <Button
                                variant="contained"
                                onClick={() => {
                                  submitForm();
                                }}
                              >
                                Save
                              </Button>
                            </Box>
                          </Box>
                        </Form>
                      );
                    }}
                  </Formik>
                </If>
                <Box className={classes.TooltipEditedDate} mt={2}>
                  <Typography variant="body1">
                    Edited {moment(dashBoardComment?.updatedAt).format('MMM D') || ''}
                  </Typography>
                  <If condition={!showCommentEditor}>
                    <EditIcon
                      onClick={() => {
                        setShowCommentEditor(true);
                      }}
                    />
                  </If>
                </Box>
              </Popover>
            </div>
          );
        }}
      </PopupState> */}
      </Box>
    </>
  );
}
